import { Colors } from "@auteco/theme"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(() => ({
    container: {
        padding: '20px'
    },
    cardSection: {
        background: Colors.GRAY_BACKGROUND,
        padding: '4px'
    },
    mainContainerBtns: {
        width: '404px',
        margin: '0 auto 12px',
        padding: '4px',
        background: Colors.GRAY_BACKGROUND,
        borderRadius: '4px'
    },
    containerBtns: {
        display: 'flex',
        borderRadius: '4px',
        overflow: 'hidden'
    },
    btn: {
        width: '200px',
        background: Colors.GRAY_BACKGROUND,
        borderRadius: '0'
    },
    selectedBtn: {
        width: '200px',
        borderRadius: '0',
        background: Colors.DARK_BLUE,
        color: 'white',
        '&:hover': {
            background: Colors.DARK_BLUE
        }
    },
    unassignedCard: {
        margin: '20px 0 0',
        padding: '20px'
    },
    unassignedTitle: {
        marginBottom: '20px',
        fontSize: '20px',
        color: Colors.DARK_BLUE
    },
    unassignedBtn: {
        marginTop: '12px'
    }
}))

export default useStyles